"use strict";
var Observable_1 = require('../../Observable');
var onErrorResumeNext_1 = require('../../observable/onErrorResumeNext');
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/rxjs/add/observable/onErrorResumeNext.js
// module id = ../../../../rxjs/add/observable/onErrorResumeNext.js
// module chunks = 37